import React from 'react';
import { ReactComponent as FavoriteCheck } from 'assets/icons/favorite-check.svg';
import { ReactComponent as FavoriteUncheck } from 'assets/icons/favorite-uncheck.svg';

type FavoriteIconProps = {
	checked: boolean;
	size?: number;
};

export const FavoriteIcon = ({ checked, size = 18 }: FavoriteIconProps) => {
	return checked ? <FavoriteCheck width={size} height={size} /> : <FavoriteUncheck width={size} height={size} />;
};
